export default __webpack_public_path__ + "static/media/contact.91a6fca2.svg";